import React from 'react';
import { Route, RouteProps } from 'react-router-dom';
import LogIn from './LogIn';
import Disabled from './Disabled';

export type ProtectedRouteProps = {
  isAuthenticated: boolean;
  isDisabled: boolean
} & RouteProps;

 const ProtectedRoute = ({ isDisabled, isAuthenticated, ...routeProps }: ProtectedRouteProps) => {
    if(isAuthenticated) {
      if(!isDisabled){
        return <Route {...routeProps}/>;

      } else {
        return <Route {...routeProps} component={Disabled}/>
      }
    } else {
      return <Route {...routeProps} component={LogIn} />;
    }
  
};

export default ProtectedRoute;